import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {BaseComponent} from '../../BaseComponent';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {UserModel} from '../../../models/UserModel';
import {Platform} from '@ionic/angular';
import {forkJoin, Observable} from 'rxjs';
import {ProviderAnagrafService} from '../../general-services/service-provider-anagraf/provider-anagraf.service';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {AllSettingsFilterModel} from '../../../models/AllSettingsFilterModel';
import * as servers from '../../../services/api/servers';
import {Title} from '@angular/platform-browser';
import { ServiceChangesService } from 'src/app/service-changes/service/service-changes.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends BaseComponent implements OnInit, OnChanges {
  user: UserModel;
  mobile: boolean;
  providerData: any;
  userProviderList: any;
  providerSelected: any;
  filterSingle: AllSettingsFilterModel;
  titleBarName: string;

  @Input() menuLink: string;
  @Input() menuHeader: string;
  @Input() new: string;
  @Input() element: string;
  @Input() title: string;
  @Input() url: string;
  @Input() backUrl: string = null;
  @Input() showBack: boolean;
  @Input() showNew: boolean;


  constructor(route: ActivatedRoute,
              router: Router,
              platform: Platform,
              private loaderService: LoaderService,
              private _location: Location,
              private providerService: ProviderAnagrafService,
              private serviceChange: ServiceChangesService,
              private titleService: Title) {
    super(route, router);
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.userProviderList =  this.user.providerList;
    this.mobile = this.checkMobile(platform);
  }

  async ngOnInit() {
    const baseName = 'ABC';
    const baseTitleBarName = `${baseName}3`;
    const apice3 = '&#179;';
    const baseTitle = baseName + apice3;

    switch (servers.viewMode) {
      case 'DEV':
        this.PROJECT_NAME = `${baseTitle} - DEV`;
        this.titleBarName = `${baseTitleBarName} - DEV`;
        break;

      case 'CERT':
        this.PROJECT_NAME = `${baseTitle} - CERT`;
        this.titleBarName = `${baseTitleBarName} - CERT`;
        break;

      case 'PROD':
        this.PROJECT_NAME = `${baseTitle}`;
        this.titleBarName = `${baseTitleBarName}`;
        break;

      case '':
      case 'LOCALHOST':
      case null:
      default:
        this.PROJECT_NAME = `${baseTitle} - LOCALHOST`
        this.titleBarName = `${baseTitleBarName} - LOCALHOST`;
        break;
    }
    this.titleService.setTitle(this.titleBarName);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.url = this.menuHeader
      .split('?')[0]
      .split('/')[1]
      .replace('/', '')
      .replace(/-/gi, ' ');

    if (sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED) === null) {
      this.initProvider();
    } else {
      const reload = true;
      this.initProvider(reload);
    }

    if (this.url == 'monthly actual') {
      this.url = 'monthly volumes'
    }
  }

  async logout() {
    await sessionStorage.clear();
    this.baseRouter.navigate([this.LINKS.LOGIN]);
  }

  onResize(event) {
    if (event.target.innerWidth <= 1024) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  initProvider(reload?: boolean) {
    this.loaderService.display(true);
    this.filterSingle = AllSettingsFilterModel.getFromLogin();
    const getFirstProviderObservable: Observable<any> = this.providerService.getListInAllSettings(
      this.providerService.baseUrl,
      this.filterSingle,
      ).pipe();

    forkJoin([getFirstProviderObservable])
      .subscribe(
        (resultFork: any) => {
          this.providerData = resultFork[0];
          if (reload) {
            this.providerSelected = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
          } else {
            this.providerSelected = resultFork[0] ? resultFork[0][0] : null;
            sessionStorage.setItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED, JSON.stringify(this.providerSelected));
                      }
          this.serviceChange.providerDefault$.next(this.providerSelected);
          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  updateProvider(event) {
    sessionStorage.setItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED, JSON.stringify(event));
    this.resetSessionStorageFilters();
    this.router.navigate([this.LINKS.HOMEPAGE]);
  }

  getColor() {
    switch (servers.viewMode) {
      case 'DEV':
        return 'yellow';

      case 'CERT':
        return 'green';

      case 'PROD':
      case '':
      case 'LOCALHOST':
      case null:
      default:
        break;
    }
  }
}
